<template>
    <div class="">
        <ul class="pagination-list">
            <li class="pagination-item prev-icon" @click="goPage(1)"></li>
            <li :class="dataObj.currPage === i ? 'pagination-item active':'pagination-item'" 
            v-for="i in pageList"
            @click="selectPage(i)">{{ i }}</li>
            <li class="pagination-item next-icon" @click="goPage(2)"></li>
        </ul>
    </div>
</template>
<script>
    export default {
        props:{
            dataObj:{
                type:Object,
                default:()=> {
                    return{total:80,pageSize:100,currPage:1}
                }
            }
        },
        computed:{
            pageList: function(){
                let obj = this.dataObj;
                let totalPage = Math.ceil(obj.total/obj.pageSize);
                let list = [];
                for(let i = 1;i<=totalPage;i++){
                    list.push(i);
                }
                if(totalPage>5){
                    if(totalPage - obj.currPage > 4){
                        list = [obj.currPage,obj.currPage+1,obj.currPage+2,'...',totalPage-1,totalPage];
                    }else{
                        list = [obj.currPage-4,obj.currPage-3,obj.currPage-2,obj.currPage-1,obj.currPage];
                    }
                }
                return list;
            },
            totalPage:function(){
                let obj = this.dataObj;
                return Math.ceil(obj.total/obj.pageSize);
            }
        },
        data(){
            return {}
        },
        mounted(){
            console.log(1)
        },
        methods:{
            selectPage(index){
                if(index !== '...'){
                    this.dataObj.currPage = index;
                    this.$emit('queryPage',{current:this.dataObj.currPage});
                }
            },
            goPage(flag){
                if(flag === 1){
                    //上一页
                    this.dataObj.currPage - 1 > 0  ? this.selectPage(this.dataObj.currPage - 1) : '';
                }else{
                    //下一页
                    this.dataObj.currPage + 1 <= this.totalPage ? this.selectPage(this.dataObj.currPage + 1) : ''
                }
            }
        }
    }
</script>
<style scoped>
    .pagination-list{
        margin-top: 64px;
        display: flex;
        justify-content: center;
    }
    .pagination-item{
        width:36px;
        height: 36px;
        line-height: 36px;
        margin: 0 12px;
        background-color: #FFE0E0;
        font-size: 18px;
        font-family: Source Han Sans;
        font-weight: 300;
        color: #D86A6A;
        text-align: center;
        border-radius: 50%;
    }
    .pagination-item:hover{
        cursor: pointer;
    }
    .active.pagination-item{
        background: #E60012;
        color: #fff;
    }
    .prev-icon{
        background: url('../assets/icon/icon_arrows_L.png') center no-repeat;
        background-size: 32px auto;
        transform: rotateY(180deg);
    }
    .next-icon{
        background: url('../assets/icon/icon_arrows_L.png') center no-repeat;
        background-size: 32px auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/pagination-view.vue